import { parsePhoneNumber } from 'libphonenumber-js/max'
import { defineRule } from 'vee-validate';

export const useLibPhoneValidation = () => {
  defineRule('phone', (value: string) => {
    // Field is empty, should pass
    if (!value || !value.length) {
      return true;
    }
    try {
      const phoneNumber = parsePhoneNumber(value, 'DE')
      if (phoneNumber
        && phoneNumber.country === 'DE'
        && phoneNumber.isPossible() === true
        && phoneNumber.isValid() === true) {
        return true;
      } else {
        return 'Bitte geben Sie eine gültige Telefonnummer ein';
      }
    } catch (error) {
      return 'Bitte geben Sie eine gültige Telefonnummer ein';
    }
  });
  return { parsePhoneNumber }
}
